import { Theme } from '@mui/material/styles'

// ----------------------------------------------------------------------
// The wash behind a modal, a drawer or a dialog.
//
// It used to be a gradient built from `grey[900]`, which is the neutral ramp's
// ink and therefore inverts with the colour scheme: in dark mode the overlay
// resolved to a near opaque `rgba(244,245,247,1)`, a white sheet over the whole
// console. A scrim is darkness, not the far end of a ramp, so it comes from the
// `scrim` role, which is built on true black in both schemes.
//
// Light mode changes too, and visibly: it was a 75 degree gradient running from
// 48 per cent to fully opaque, and it is a flat 45 per cent. Every dialog and
// drawer in the default scheme looks different, which is the point — a scrim
// that reaches opacity at one corner is hiding the application, not dimming it.
// ----------------------------------------------------------------------

export default function Backdrop(theme: Theme) {
  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          'backgroundColor': theme.palette.scrim,
          '&.MuiBackdrop-invisible': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
  }
}
